import React from 'react';
import {PopoverMenuOptionProps} from "./option";
import FieldHelp from "../../../../../gd-components/help-and-hint/field-help/field-help";

export default function OptionText(props:PopoverMenuOptionProps) {

    const onMouseEnter = () => {
        props.onSetHelpMessage?.(props.option.hint)
    }

    const onMouseLeave = () => {
        props.onSetHelpMessage?.(null)
    }

    const onClick = () => {
        if (!props.option.disabled) props.onClick(props.option);
    }

    const classes = Classes('option', {
        'highlighted'   : props.isHighlighted,
        'is-selected'   : props.isSelected,
        disabled        : props.option.disabled
    })

    const valueClass = Classes('label', {
        bold: props.isSelected,
    })

    const style : style = props.option.description ? {
        height      : 'unset',
        minHeight   : '36',
        whiteSpace  : 'normal',
        // maxWidth    : 250,
    } : {}

    const icoClasses = Classes("ico", props.option.icon, {
        'line-height-unset': !!props.option.description
    })

    return (
        <div className      = {classes}
             style          = {style}
             onMouseEnter   = {onMouseEnter}
             onMouseLeave   = {onMouseLeave}
             onClick        = {onClick}>
            <div className="flex-column-left-top w-100-percent m-t-8 m-b-8">
                <div className="flex-row-left-center flex-wrap w-100-percent ui5-txt-no-accent-tiny">
                    {props.option.icon && <div className={icoClasses}/>}
                    {props.option.iconComponent}
                    <div className={valueClass}>{props.option.label}</div>
                    {!!props.option.hint &&
                        <div className="flex-row-right-center flex-1">
                            <FieldHelp className="option-hint m-l-8" message={props.option.hint}/>
                        </div>}
                </div>

                {!!props.option.description &&
                    <div className="flex-row-left-center w-100-percent ui5-txt-no-accent-tiny m-t-5" style={{lineHeight: '140%'}}>
                        {props.option.description}
                    </div>}
            </div>
        </div>
    )
}
